var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _vm.filters
        ? _c(
            "div",
            {
              staticClass: "saved-sort-filters faux-fixed",
              class: { "saved-sort-filters--opened": _vm.showCategoryFilters }
            },
            [
              _c(
                "div",
                {
                  staticClass: "main-filter-container",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.toggleFilters.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "main-filter" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.filters[_vm.selectedCategoryFilter]
                            .product_category_title
                        ) +
                        "\n            "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade-fast" } }, [
                _vm.showCategoryFilters
                  ? _c(
                      "div",
                      { staticClass: "saved-products-filter-container" },
                      [
                        _c("a", {
                          staticClass: "close",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggleFilters.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "occasion-filter-container further-down"
                          },
                          _vm._l(_vm.filters, function(filter, index) {
                            return _c(
                              "div",
                              {
                                staticClass: "filter",
                                class: {
                                  active: index === _vm.selectedCategoryFilter
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.setCategoryFilterIndex(
                                      index,
                                      filter
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(filter.product_category_title) +
                                    "\n                    "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-container saved-products-container" },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            !_vm.savedProducts || _vm.dataLoading
              ? _c(
                  "div",
                  { key: 1, staticClass: "loading-overlay" },
                  [_c("loader")],
                  1
                )
              : _c("div", { key: "2" }, [
                  _vm.savedProducts.length < 1
                    ? _c("div", [
                        _c("div", { staticClass: "no-results-message" }, [
                          _vm._v(
                            "\n                        You currently don't have any saved items " +
                              _vm._s(
                                _vm.savedProductsCount > 0
                                  ? "with those filters"
                                  : ""
                              ) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _c(
                        "div",
                        { staticClass: "saved-items-container" },
                        [
                          _c(
                            "transition-group",
                            {
                              attrs: {
                                name: "fade",
                                mode: "out-in",
                                duration: { enter: 200, leave: 100 }
                              }
                            },
                            [
                              _c(
                                "div",
                                { key: 1, staticClass: "products-list-view" },
                                _vm._l(_vm.savedProducts, function(product) {
                                  return _c("saved-product-item", {
                                    key: product.product_id,
                                    attrs: { product: product },
                                    on: {
                                      "data-loading": _vm.productLoading,
                                      "requested-swap": _vm.handleSwapRequest,
                                      unsave: _vm.openUnsaveModal
                                    }
                                  })
                                }),
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "back-button",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.$router.go(-1)
            }
          }
        },
        [_vm._v("\n        Back\n    ")]
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showSwapProduct
            ? _c("swap-item", {
                attrs: {
                  product: _vm.swapProduct,
                  showSizes: true,
                  swapCb: _vm.onSwapProduct
                },
                on: {
                  close: function($event) {
                    _vm.showSwapProduct = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.unsaveModalOpened
        ? _c("unsave-item-modal", {
            attrs: {
              itemType: "product",
              confirm: _vm.unsaveProduct,
              close: _vm.closeUnsaveModal,
              loading: _vm.unsaveLoading
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb4c6ba2", { render: render, staticRenderFns: staticRenderFns })
  }
}